// 8 category definitions driving the reusable category template (§5).
// Placeholder copy of the right shape — no invented factory names or client claims.

const MOTIFS = {
  bolt: '<svg viewBox="0 0 200 200"><g fill="none" stroke="#fff" stroke-width="6"><path d="M70 30 h60 l20 20 v20 l-20 20 h-60 l-20 -20 v-20 z"/><line x1="100" y1="90" x2="100" y2="170"/><line x1="88" y1="110" x2="112" y2="110"/><line x1="88" y1="130" x2="112" y2="130"/><line x1="88" y1="150" x2="112" y2="150"/></g></svg>',
  gear: '<svg viewBox="0 0 200 200"><g fill="none" stroke="#fff" stroke-width="6"><circle cx="100" cy="100" r="42"/><circle cx="100" cy="100" r="14"/><g stroke-width="8"><line x1="100" y1="30" x2="100" y2="50"/><line x1="100" y1="150" x2="100" y2="170"/><line x1="30" y1="100" x2="50" y2="100"/><line x1="150" y1="100" x2="170" y2="100"/><line x1="52" y1="52" x2="66" y2="66"/><line x1="134" y1="134" x2="148" y2="148"/><line x1="148" y1="52" x2="134" y2="66"/><line x1="66" y1="134" x2="52" y2="148"/></g></g></svg>',
  thread: '<svg viewBox="0 0 200 200"><g fill="none" stroke="#fff" stroke-width="5"><rect x="60" y="30" width="80" height="140" rx="8"/><path d="M60 60 h80 M60 90 h80 M60 120 h80 M60 150 h80"/><path d="M100 30 q40 40 0 70 q-40 30 0 70"/></g></svg>',
  chip: '<svg viewBox="0 0 200 200"><g fill="none" stroke="#fff" stroke-width="5"><rect x="60" y="60" width="80" height="80" rx="6"/><rect x="82" y="82" width="36" height="36"/><g><line x1="70" y1="45" x2="70" y2="60"/><line x1="100" y1="45" x2="100" y2="60"/><line x1="130" y1="45" x2="130" y2="60"/><line x1="70" y1="140" x2="70" y2="155"/><line x1="100" y1="140" x2="100" y2="155"/><line x1="130" y1="140" x2="130" y2="155"/><line x1="45" y1="80" x2="60" y2="80"/><line x1="45" y1="120" x2="60" y2="120"/><line x1="140" y1="80" x2="155" y2="80"/><line x1="140" y1="120" x2="155" y2="120"/></g></g></svg>',
  gift: '<svg viewBox="0 0 200 200"><g fill="none" stroke="#fff" stroke-width="5"><rect x="55" y="80" width="90" height="80"/><rect x="48" y="60" width="104" height="24"/><line x1="100" y1="60" x2="100" y2="160"/><path d="M100 60 q-30 -10 -30 -26 q0 -14 30 6 q30 -20 30 -6 q0 16 -30 26"/></g></svg>',
  chair: '<svg viewBox="0 0 200 200"><g fill="none" stroke="#fff" stroke-width="6"><path d="M70 40 v70 M70 110 h60 M130 60 v50 M70 110 l-6 50 M130 110 l6 50"/><path d="M70 60 h60"/></g></svg>',
  medical: '<svg viewBox="0 0 200 200"><g fill="none" stroke="#fff" stroke-width="6"><rect x="55" y="55" width="90" height="90" rx="12"/><line x1="100" y1="75" x2="100" y2="125"/><line x1="75" y1="100" x2="125" y2="100"/></g></svg>',
  compass: '<svg viewBox="0 0 200 200"><g fill="none" stroke="#fff" stroke-width="6"><circle cx="100" cy="100" r="60"/><path d="M100 55 L115 100 L100 145 L85 100 Z"/></g></svg>',
};

export const CATEGORIES = [
  {
    slug: "fasteners",
    name: "Fasteners & Hardware",
    tier: 1,
    badge: "★ DEEP EXPERTISE",
    motif: MOTIFS.bolt,
    positioning:
      "This is our deepest category. Working hand-in-hand with an IATF 16949–certified fastener plant, we read your drawings, argue grades and coatings with engineers, and deliver PPAP-backed parts to DIN, ISO, ASTM, JIS and IS standards.",
    keyword: "fastener sourcing china india · bolt manufacturer sourcing agent",
    metaDesc:
      "Source bolts, screws, studs and threaded fasteners direct from an IATF 16949–certified plant — grades 4.8 to 12.9, DIN/ISO/ASTM/JIS/IS, PPAP documentation.",
    range: [
      "Bolts, screws, nuts, studs, threaded rods",
      "Structural, machine, self-tapping & socket screws",
      "Washers, fittings, anchors and specials",
      "Grades 4.8 / 8.8 / 10.9 / 12.9",
      "Drawing-based bespoke fasteners",
      "Small-to-large diameter, metric & imperial",
    ],
    standards: [
      "IATF 16949 quality management system",
      "DIN · ISO · ASTM · JIS · IS standard conformance",
      "Coatings: zinc, ZnNi, HDG, geomet, PTFE",
      "PPAP documentation & material certificates",
      "Salt-spray, torque and tensile test reports",
      "Full traceability from heat number to lot",
    ],
    countries: [
      { flag: "🇮🇳", name: "India", strength: "Best — quality + tariff edge", fit: "Partner plant; drawings, grades, PPAP" },
      { flag: "🇨🇳", name: "China", strength: "Scale & low cost", fit: "High-volume commodity fasteners" },
      { flag: "🇻🇳", name: "Vietnam", strength: "Limited", fit: "Rarely the right source for fasteners" },
      { flag: "🇹🇭", name: "Thailand", strength: "Niche", fit: "Selected automotive specials only" },
    ],
    faq: [
      { q: "Can you make fasteners to my drawing?", a: "Yes. Drawing-based fasteners are a core strength — send the drawing with grade, coating and standard, and we quote feasibility and PPAP scope with our manufacturing partner." },
      { q: "Which grades and standards do you cover?", a: "Grades 4.8, 8.8, 10.9 and 12.9 across DIN, ISO, ASTM, JIS and IS, with zinc, ZnNi, HDG and geomet coatings." },
      { q: "Do you provide PPAP and material certificates?", a: "Yes — PPAP documentation, material certificates and test reports (salt-spray, torque, tensile) are available with full lot traceability." },
      { q: "What is the minimum order?", a: "MOQ depends on grade, size and coating. Share your part and target volume and we confirm the reality check per brief." },
    ],
  },
  {
    slug: "cycle-parts",
    name: "Cycle Parts",
    tier: 2,
    badge: "MARKET FLUENCY",
    motif: MOTIFS.gear,
    positioning:
      "Ludhiana is India's cycle capital and our home ground. We buy frames, chains, hubs and components here every quarter, and know the equivalent Chinese ecosystem well enough to place your order in the country that fits your volume and price point.",
    keyword: "cycle parts sourcing india china",
    metaDesc:
      "Source bicycle frames, chains, hubs and components from India's cycle capital Ludhiana and China's full ecosystem — verified suppliers, QC and consolidation.",
    range: [
      "Frames, forks and rigid components",
      "Chains, freewheels, sprockets, hubs",
      "Rims, spokes, tyres and tubes",
      "Brakes, pedals, saddles, handlebars",
      "E-bike drivetrains and controllers",
      "Complete knock-down (CKD) kits",
    ],
    standards: [
      "Supplier audit before first order",
      "Pre-shipment AQL inspection",
      "Dimensional and finish checks",
      "Load and fatigue test coordination",
      "Consolidation across multiple vendors",
      "Export documentation handled",
    ],
    countries: [
      { flag: "🇨🇳", name: "China", strength: "Best — full ecosystem", fit: "Every component under one roof" },
      { flag: "🇮🇳", name: "India", strength: "Strong, growing", fit: "Ludhiana cluster, tariff-friendly" },
      { flag: "🇻🇳", name: "Vietnam", strength: "Assembly", fit: "Final assembly for tariff routing" },
      { flag: "🇹🇭", name: "Thailand", strength: "Limited", fit: "Selected components only" },
    ],
    faq: [
      { q: "Should I buy cycle parts from China or India?", a: "China has the fuller ecosystem for every component; India (Ludhiana) is strong, growing and tariff-friendly. We match your volume and price point to the right source." },
      { q: "Can you consolidate parts from many suppliers?", a: "Yes — we consolidate multi-vendor orders into one shipment with combined QC and export documentation." },
      { q: "Do you inspect before shipment?", a: "Every order includes a pre-shipment AQL inspection with dimensional and finish checks before the balance moves." },
      { q: "Can you handle e-bike drivetrains?", a: "Yes, including drivetrains and controllers, with test coordination as required." },
    ],
  },
  {
    slug: "textiles",
    name: "Textiles & Hosiery Accessories",
    tier: 2,
    badge: "MARKET FLUENCY",
    motif: MOTIFS.thread,
    positioning:
      "From Tirupur knits to Keqiao synthetics, we buy trims, zips, drawcords, labels and elastics across India and China every quarter. Textiles and hosiery accessories are a market we know by hand, not by catalogue.",
    keyword: "textile sourcing india china · hosiery accessories sourcing",
    metaDesc:
      "Source knitwear, trims, zips, drawcords, labels and elastics from India (Tirupur) and China (Keqiao) — verified suppliers, AQL inspection and consolidation.",
    range: [
      "Knitwear, hosiery and socks",
      "Zips, drawcords, elastics, tapes",
      "Woven and printed labels, hang tags",
      "Buttons, buckles and trims",
      "Cotton, linen and blended fabrics",
      "Packaging and finishing accessories",
    ],
    standards: [
      "Fabric and colour approval workflow",
      "Sealed golden-sample sign-off",
      "AQL inspection on finished goods",
      "Oeko-Tex / test-report coordination",
      "Shade-band and shrinkage checks",
      "Consolidated export shipping",
    ],
    countries: [
      { flag: "🇮🇳", name: "India", strength: "Best — cotton, knits, craft", fit: "Tirupur, Ludhiana hosiery clusters" },
      { flag: "🇨🇳", name: "China", strength: "Synthetics, speed", fit: "Keqiao synthetics and fast turnaround" },
      { flag: "🇻🇳", name: "Vietnam", strength: "Volume garments", fit: "Large garment runs" },
      { flag: "🇹🇭", name: "Thailand", strength: "Limited", fit: "Niche finishing only" },
    ],
    faq: [
      { q: "Where should I source cotton knitwear?", a: "India (Tirupur and Ludhiana) leads on cotton, knits and craft; China's Keqiao is strongest for synthetics and speed." },
      { q: "Do you manage colour and shade approval?", a: "Yes — fabric and colour approval, sealed golden samples, shade-band and shrinkage checks are part of the workflow." },
      { q: "Can you coordinate Oeko-Tex or test reports?", a: "Yes, we coordinate the required test reports with the mill or an accredited lab." },
      { q: "Do you handle small trim orders?", a: "We handle trims, zips, labels and elastics, consolidating multiple small orders where it makes sense." },
    ],
  },
  {
    slug: "electronics",
    name: "Electronics",
    tier: 2,
    badge: "MARKET FLUENCY",
    motif: MOTIFS.chip,
    positioning:
      "Consumer devices, accessories and components from the Huaqiangbei and Shenzhen belts. We buy electronics quarterly and apply the same verify-before-you-advance discipline to a category where trader-vs-factory confusion is common.",
    keyword: "electronics sourcing china shenzhen",
    metaDesc:
      "Source consumer electronics, accessories and components from Shenzhen and Huaqiangbei — factory-vs-trader verification, AQL inspection and safe payment.",
    range: [
      "Consumer devices and gadgets",
      "Cables, chargers and accessories",
      "Components and modules",
      "Audio, lighting and small appliances",
      "OEM/ODM electronics",
      "Battery and power products (compliance-led)",
    ],
    standards: [
      "Factory-vs-trader verification",
      "License and bank-beneficiary matching",
      "Function and safety sampling",
      "CE / FCC / BIS test coordination",
      "Pre-shipment AQL inspection",
      "Battery shipping compliance guidance",
    ],
    countries: [
      { flag: "🇨🇳", name: "China", strength: "Best — unmatched depth", fit: "Shenzhen / Huaqiangbei full stack" },
      { flag: "🇮🇳", name: "India", strength: "Assembly rising", fit: "Growing assembly base" },
      { flag: "🇻🇳", name: "Vietnam", strength: "Assembly hub", fit: "Assembly for tariff routing" },
      { flag: "🇹🇭", name: "Thailand", strength: "Components", fit: "Selected components" },
    ],
    faq: [
      { q: "Is my electronics supplier a factory or a trader?", a: "We verify factory-vs-trader status, licenses and bank-beneficiary matching before you advance any payment — a common risk in electronics." },
      { q: "Can you coordinate CE, FCC or BIS testing?", a: "Yes, we coordinate the relevant compliance testing with accredited labs as your market requires." },
      { q: "Do you handle products with batteries?", a: "Yes, with battery shipping compliance guidance; certification remains market-dependent." },
      { q: "Where is best for electronics?", a: "China (Shenzhen / Huaqiangbei) has unmatched depth; Vietnam and India are rising assembly options for tariff routing." },
    ],
  },
  {
    slug: "yiwu",
    name: "Yiwu General Goods",
    tier: 2,
    badge: "MARKET FLUENCY",
    motif: MOTIFS.gift,
    positioning:
      "Toys, stationery, festival goods and houseware from Yiwu — 75,000 booths in one city, all five districts mapped. We turn the world's largest small-commodity market into a shortlist you can actually buy from.",
    keyword: "yiwu market sourcing agent · yiwu buying agent",
    metaDesc:
      "Source general merchandise from Yiwu — toys, stationery, festival goods and houseware. All five districts mapped, local export handling and consolidation.",
    range: [
      "Toys and novelties",
      "Stationery and office goods",
      "Festival and party goods",
      "Houseware and kitchen items",
      "Promotional and gift items",
      "Mixed-container consolidation",
    ],
    standards: [
      "District-by-district booth shortlisting",
      "Local export agent handling",
      "Quality spot-checks on samples",
      "Mixed-supplier consolidation",
      "Packaging and labelling coordination",
      "Full-container and LCL options",
    ],
    countries: [
      { flag: "🇨🇳", name: "China", strength: "Best — Yiwu", fit: "75,000 booths, one city" },
      { flag: "🇮🇳", name: "India", strength: "Handicrafts", fit: "Craft and gifting alternatives" },
      { flag: "🇻🇳", name: "Vietnam", strength: "Limited", fit: "Rarely the right source" },
      { flag: "🇹🇭", name: "Thailand", strength: "Limited", fit: "Selected gift items only" },
    ],
    faq: [
      { q: "How do you handle Yiwu's scale?", a: "We map all five districts and turn 75,000 booths into a focused shortlist for your product, then handle local export and consolidation." },
      { q: "Can I mix many products in one container?", a: "Yes — mixed-supplier consolidation into full-container or LCL shipments is standard for Yiwu buying." },
      { q: "Do you check quality in Yiwu?", a: "We run quality spot-checks on samples and coordinate packaging and labelling before consolidation." },
      { q: "Is Yiwu only for China?", a: "Yiwu is China's market; for craft or gifting alternatives, India can be a better fit for some lines." },
    ],
  },
  {
    slug: "furniture",
    name: "Furniture",
    tier: 3,
    badge: "NETWORK SOURCING",
    motif: MOTIFS.chair,
    positioning:
      "Furniture runs through vetted specialist partners across Foshan, Jodhpur and Binh Duong — under the same verification standard we apply to everything else. We are honest that this is network sourcing, not in-house manufacturing.",
    keyword: "furniture sourcing vietnam china",
    metaDesc:
      "Source furniture from Vietnam (Binh Duong), China (Foshan) and India (Jodhpur) through vetted specialist partners under The Sourcing Atlas verification standard.",
    range: [
      "Solid wood and engineered wood furniture",
      "Upholstery and seating",
      "Office and hospitality furniture",
      "Outdoor and rattan furniture",
      "Flat-pack and knock-down designs",
      "Custom finishes and specifications",
    ],
    standards: [
      "Partner sourced through vetted network",
      "Same verification standard applied",
      "Material and finish approval",
      "Moisture and construction checks",
      "Pre-shipment AQL inspection",
      "Container loading supervision",
    ],
    countries: [
      { flag: "🇻🇳", name: "Vietnam", strength: "Best — wood + tariffs", fit: "Binh Duong wood cluster" },
      { flag: "🇨🇳", name: "China", strength: "Foshan scale", fit: "Broadest range and price" },
      { flag: "🇮🇳", name: "India", strength: "Solid wood, Jodhpur", fit: "Solid wood and craft pieces" },
      { flag: "🇹🇭", name: "Thailand", strength: "Mid-range", fit: "Selected mid-range lines" },
    ],
    faq: [
      { q: "Do you manufacture furniture yourselves?", a: "No — furniture runs through vetted specialist partners, and we say so plainly. We apply the same verification and inspection standard we use everywhere." },
      { q: "Where is best for furniture?", a: "Vietnam (Binh Duong) leads on wood and tariffs; China (Foshan) has the broadest range; India (Jodhpur) is strong for solid wood." },
      { q: "How do you protect quality with partners?", a: "Partners are vetted, and every order gets material/finish approval, moisture and construction checks, AQL inspection and loading supervision." },
      { q: "Can you handle custom finishes?", a: "Yes, custom finishes and specifications are supported through the partner network." },
    ],
  },
  {
    slug: "medical",
    name: "Medical Equipment",
    tier: 3,
    badge: "NETWORK SOURCING",
    motif: MOTIFS.medical,
    positioning:
      "Devices and consumables through vetted specialist partners, regulatory-first. Important: certification and import licensing for medical equipment remain the buyer's compliance responsibility — we source and verify, you own the regulatory pathway.",
    keyword: "medical equipment sourcing china india",
    metaDesc:
      "Source medical devices and consumables through vetted specialist partners. Regulatory-first — certification and import licensing remain the buyer's responsibility.",
    range: [
      "Disposables and consumables",
      "Basic diagnostic devices",
      "Hospital and clinic furniture",
      "PPE and safety products",
      "Rehabilitation and mobility aids",
      "Non-sterile general equipment",
    ],
    standards: [
      "Partner sourced through vetted network",
      "Same verification standard applied",
      "Document and license review support",
      "Sample approval workflow",
      "Pre-shipment AQL inspection",
      "Regulatory pathway is buyer-owned",
    ],
    countries: [
      { flag: "🇨🇳", name: "China", strength: "Best — breadth", fit: "Widest device and consumable range" },
      { flag: "🇮🇳", name: "India", strength: "Consumables strong", fit: "Strong on consumables and PPE" },
      { flag: "🇻🇳", name: "Vietnam", strength: "Emerging", fit: "Emerging, selected lines" },
      { flag: "🇹🇭", name: "Thailand", strength: "Selected devices", fit: "Selected quality devices" },
    ],
    faq: [
      { q: "Who is responsible for medical certification?", a: "Certification and import licensing remain the buyer's compliance responsibility. We source and verify suppliers; you own the regulatory pathway for your market." },
      { q: "Do you manufacture medical equipment?", a: "No — this category runs through vetted specialist partners under our verification standard." },
      { q: "Where is best for medical goods?", a: "China has the widest breadth; India is strong on consumables and PPE; Vietnam and Thailand cover selected lines." },
      { q: "Can you help with documentation?", a: "We support document and license review and a sample approval workflow, but the regulatory approval itself is buyer-owned." },
    ],
  },
  {
    slug: "other",
    name: "Other Categories",
    tier: null,
    badge: "TELL US WHAT YOU NEED",
    motif: MOTIFS.compass,
    positioning:
      "Don't see your product? Tell us what you need and we will say honestly whether we are the right partner for it — and if we are not, we will usually point you in a sensible direction.",
    keyword: "sourcing agent india china",
    metaDesc:
      "Tell The Sourcing Atlas what you need to source from China, India, Vietnam or Thailand — we give an honest answer on whether we are the right partner.",
    range: [
      "Any manufactured product enquiry",
      "Cross-category and mixed orders",
      "New product development ideas",
      "Private-label opportunities",
      "China+1 diversification requests",
      "One-off and pilot orders",
    ],
    standards: [
      "Honest feasibility assessment",
      "Country recommendation",
      "Verification standard applied",
      "Sample and inspection workflow",
      "Transparent, disclosed commission",
      "Clear go / no-go answer",
    ],
    countries: [
      { flag: "🇨🇳", name: "China", strength: "Depends on product", fit: "Scale and breadth" },
      { flag: "🇮🇳", name: "India", strength: "Depends on product", fit: "Craft and engineering" },
      { flag: "🇻🇳", name: "Vietnam", strength: "Depends on product", fit: "Wood, garments, assembly" },
      { flag: "🇹🇭", name: "Thailand", strength: "Depends on product", fit: "Auto, food, rubber" },
    ],
    faq: [
      { q: "What if my product isn't listed?", a: "Tell us the product, target volume and destination — we give an honest feasibility answer and a country recommendation, even if that means telling you we are not the right fit." },
      { q: "Do you take one-off or pilot orders?", a: "Yes, we handle one-off and pilot orders as well as ongoing programs." },
      { q: "How is your fee structured?", a: "A transparent commission on order value, quoted per brief and disclosed up front — never hidden in the product price." },
      { q: "Can you help with China+1 diversification?", a: "Yes — country benchmarking, landed-cost comparison and a verified alternate supplier are core to our China+1 desk." },
    ],
  },
];

export const bySlug = (slug) => CATEGORIES.find((c) => c.slug === slug);
